import { numberInputAnatomy } from "@chakra-ui/anatomy";
import { createMultiStyleConfigHelpers } from "@chakra-ui/react";

const { definePartsStyle, defineMultiStyleConfig } =
  createMultiStyleConfigHelpers(numberInputAnatomy.keys);

const baseStyle = definePartsStyle({
  field: {
    borderRadius: 5,
    border: "2px solid",
    fontWeight: "600",
    background: "transparent",
    _placeholder: {
      fontWeight: "600",
      color: "gray.base",
    },
    _invalid: {
      borderColor: "error",
      color: "error",
    },
  },
});

const primary = definePartsStyle({
  field: {
    borderColor: "brand.300",
    color: "brand.300",
  },
});

export const numberInputTheme = defineMultiStyleConfig({
  baseStyle,
  variants: { primary },
  defaultProps: {
    variant: "primary",
  },
});
